/* eslint-disable css-modules/no-unused-class */
// Types
import { GiftOptionProps } from './GiftOption.types';

// Styles
import styles from './gift-option.scss';

const GiftOption = ({
  dataTest,
  giftOptionClassName,
  onClick = () => {},
  type,
}: GiftOptionProps) => {
  return (
    <button className={styles.button} data-testid={dataTest} onClick={onClick} type="button">
      <div className={styles[giftOptionClassName]} data-testid="gift-option-classname">
        <span
          className={styles.buttonText}
        >
          {type}
        </span>
      </div>
    </button>
  );
};

export default GiftOption;
